const ONFIDO_SDK_VERSION = 'v14.43.0';
const ONFIDO_SDK_DOMAIN = 'https://sdk.onfido.com/';

export const ONFIDO_DOC_TYPES = {
    ONFIDO_DOC_TYPE_VISA: 'residence_permit',
    ONFIDO_DOC_TYPE_PASSPORT: 'passport',
} as const;

export type OnfidoDocTypeKey = keyof typeof ONFIDO_DOC_TYPES;
export type OnfidoDocTypeValue = (typeof ONFIDO_DOC_TYPES)[OnfidoDocTypeKey];

export const { ONFIDO_DOC_TYPE_VISA, ONFIDO_DOC_TYPE_PASSPORT } = ONFIDO_DOC_TYPES;

export const ONFIDO_JS_BUNDLE = `${ONFIDO_SDK_DOMAIN}${ONFIDO_SDK_VERSION}`;
